// @ts-nocheck

import * as Types from '../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetPolicyDecisionQueryVariables = Types.Exact<{
  permissionAction: Types.Scalars['String']['input'];
  permissionName: Types.Scalars['String']['input'];
  resourceUid: Types.Scalars['String']['input'];
}>;

export type GetPolicyDecisionQuery = {
  getPolicyDecision: {
    decision?: { by?: { policy?: { refId?: string | null; uid: string } | null } | null } | null;
    requestedPermission?: {
      action?: string | null;
      permission?: string | null;
      resource?: { uid: string } | null;
    } | null;
  };
};

export const GetPolicyDecisionDocument = gql`
    query GetPolicyDecision($permissionAction: String!, $permissionName: String!, $resourceUid: String!) {
  getPolicyDecision(
    permissionAction: $permissionAction
    permissionName: $permissionName
    resourceUid: $resourceUid
  ) {
    decision {
      by {
        policy {
          refId
          uid
        }
      }
    }
    requestedPermission {
      action
      permission
      resource {
        uid
      }
    }
  }
}
    ` as unknown as DocumentNode<GetPolicyDecisionQuery, GetPolicyDecisionQueryVariables>;
